import Module from "@/services/Module"

export default {
    install: (app) => {
        Module.handle(app)
    }
}
